const reduxFirebaseConfig = {
  userProfile: 'profile',
  useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
}

export default reduxFirebaseConfig
